import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';
import { fonts, zIndex } from 'ui/theme';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';

export const PageContainer = styled.div`
  font-family: ${fonts.sansSerif};
`;

export const DisabledTooltip = styled(Tooltip)`
  cursor: not-allowed;
`;

export const FullWidthDisabledTooltip = styled(DisabledTooltip)`
  width: 100%;
`;

export const TooltipContentOnTopOfPopperMenu = styled(TooltipContent)`
  z-index: ${zIndex.toast};
  position: relative;
`;
